import { roundDate } from './round-date';

export const getDatesBounds = () => {
    const to = new Date();
    roundDate(to);
    const from = new Date(to);
    from.setMonth(from.getMonth() - 3);
    from.setDate(from.getDate() - 1);
    return { from, to };
};
